import { Observable } from 'rxjs';
import { DepartamentModel } from '../models/departament.model';

export abstract class DepartamentRepository {
    abstract getAllDepartaments(id: number): Observable<DepartamentModel[]>;
}
